import React, { Component } from 'react'
import Input from '../../UI/Input/Input'
import Button from '../../UI/Button/Button'
import { Row } from 'reactstrap'
import './UserForm.css'
import { updateObject, checkValidity } from '../../../shared/utility'
import FetchData from '../../../shared/fetchData'
import Select from '../../UI/Select/Select'

class UserForm extends Component {
    state = {
        user: {
            name: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'نام کاربر'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            lastname: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'نام خانوادگی کاربر'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            username: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'نام کاربری'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            cellNumber: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'شماره همراه کاربر'
                },
                validation: {
                    required: true,
                    maxLength: 11
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'رمز عبور'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            repeatPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'تکرار رمز عبور'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            }
        },
        userId: '',
        roles: [],
        role: [],
        units: [],
        unit: '',
        isUpdate: false,
        invalidSelect: false,
        showError: false,
        errorContent: '',
    }

    componentDidMount() {
        if (this.props.isUpdate == true) {
            const userInfo = this.props.userInfo
            const user = this.state.user
            user.name.value = userInfo.name != null ? userInfo.name : ''
            user.lastname.value = userInfo.lastname != null ? userInfo.lastname : ''
            user.cellNumber.value = userInfo.cellNumber != null ? userInfo.cellNumber : ''
            user.username.value = userInfo.username != null ? userInfo.username : ''
            this.setState({ user: user, userId: userInfo.id, isUpdate: this.props.isUpdate, role: userInfo.role != null && userInfo.role != '' ? userInfo.role.split(',') : [] })
        }
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/getRoles'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                this.setState({ roles: result.roles })
            })
            .catch(error => this.setState({ loading: false }))
        var info = {
            "pl": "10000",
            "pn": "1",
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                this.setState({ units: result.units })
                if (this.props.isUpdate == true) {
                    const unt = result.units.filter(u => u.id == this.props.userInfo.unitId)
                    if (unt != null && unt.length != 0) {
                        this.setState({
                            unit: {
                                value: unt[0].id,
                                label: unt[0].unitName
                            }
                        })
                    }
                }
            })
            .catch(error => this.setState({ loading: false }))
    }

    inputChangedHandlerUser = (event, controlName) => {
        const updatedControls = updateObject(this.state.user, {
            [controlName]: updateObject(this.state.user[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, this.state.user[controlName].validation),
                errorMessage: this.state.user[controlName].elementConfig.placeholder + ' صحیح نیست'
            })
        });
        this.setState({ user: updatedControls });
    }
    addRole = (event, role) => {
        if (this.state.role.includes(role)) {
            const roles = this.state.role
            for (var key = 0; key < roles.length; key++) {
                if (roles[key] == role) {
                    roles.splice(key, 1)
                }
            }
            this.setState({ role: roles })
        } else {
            const roles = this.state.role
            roles.push(role)
            this.setState({ role: roles })
        }
    }

    addUpdateUserSubmit = (event) => {
        event.preventDefault();
        this.setState({ showError: false });
        let user = { ...this.state.user };
        let hasError = false
        for (let key in this.state.user) {
            let element = { ...user[key] }
            if (!checkValidity(element.value, element.validation)) {
                if (key == 'password' || key == 'repeatPassword') {
                    if (this.props.isUpdate != true) {
                        hasError = true
                        element.valid = false
                        element.errorMessage = element.elementConfig.placeholder + ' الزامی است'
                        user[key] = element
                    }
                } else {
                    hasError = true
                    element.valid = false
                    element.errorMessage = element.elementConfig.placeholder + ' الزامی است'
                    user[key] = element
                }
            }
        }
        if (this.state.user['password'].value !== this.state.user['repeatPassword'].value) {
            hasError = true
            this.state.user['repeatPassword'].valid = false
            this.state.user['repeatPassword'].errorMessage = 'تکرار رمز عبور صحیح نیست'
        }
        if (this.state.unit == '' || this.state.unit == null) {
            hasError = true
            this.setState({ invalidSelect: true })
        }
        this.setState({ user })
        if (!hasError) {
            var info = ''
            var url = ''
            let role = ''
            if (this.state.role.length != 0) {
                for (let key in this.state.role)
                    role = role + this.state.role[key] + ','
            }
            if (this.state.isUpdate == true) {
                info = {
                    "user": {
                        "id": this.state.userId,
                        "name": this.state.user.name.value,
                        "lastname": this.state.user.lastname.value,
                        "username": this.state.user.username.value,
                        "cellNumber": this.state.user.cellNumber.value,
                        "password": this.state.user.password.value,
                        "role": role != '' ? role.substring(0, role.length - 1) : '',
                        "unitId": this.state.unit != null && this.state.unit != '' ? this.state.unit.value : ''
                    },
                    "version": "mtpx001"
                }
                var url = 'management/api/v1/users/updateUser'
            } else {
                info = {
                    "user": {
                        "name": this.state.user.name.value,
                        "lastname": this.state.user.lastname.value,
                        "username": this.state.user.username.value,
                        "cellNumber": this.state.user.cellNumber.value,
                        "password": this.state.user.password.value,
                        "role": role != '' ? role.substring(0, role.length - 1) : '',
                        "unitId": this.state.unit != null && this.state.unit != '' ? this.state.unit.value : ''
                    },
                    "version": "mtpx001"
                }
                url = 'management/api/v1/users/insertUser'
            }
            var raw = JSON.stringify(info)
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == "0") {
                        this.props.closeUserModal()
                        this.props.loadUsers()
                    } else if (result.message == 'INVALID_USERNAME' || result.message == 'INVALID_PASSWORD'
                        || result.message == 'INVALID_INPUT') {
                        const content = <div className='row justify-content-center w-100'>
                            <div className='user-error'>
                                ورودی نا معتبر
                            </div>
                        </div>
                        this.setState({ showError: true, errorContent: content })
                    } else if (result.message == 'DUPLICATE_USERNAME') {
                        const content = <div className='row justify-content-center w-100'>
                            <div className='user-error'>
                                نام کاربری تکراری است
                            </div>
                        </div>
                        this.setState({ showError: true, errorContent: content })
                    }
                })
                .catch(error => console.log(error))

        }
    }
    changeUnit = (selectedOption) => {
        this.setState({ unit: selectedOption })
        this.setState({ invalidSelect: false })
    }
    render() {

        const userInfo = []
        for (let key in this.state.user) {
            userInfo.push({
                id: key,
                config: this.state.user[key]
            });
        }
        const user = userInfo.map(formElement => {
            return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    col="6 mt-3"
                    changed={(event) => this.inputChangedHandlerUser(event, formElement.id)} />
            );
        });
        let roles = this.state.roles.map(r => {
            return (
                <div className="mt-2">
                    <label className="container role-text">{r.description}
                        <input type="checkbox"
                            onChange={(event) => this.addRole(event, r.role)}
                            checked={this.state.role !== '' && this.state.role != null && this.state.role.includes(r.role)}
                            value="ENVELOPE" id="flexCheckDefault" />
                        <span className="checkmark"></span>
                    </label>
                </div>
            )
        })

        let unitList = []
        if (this.state.units != null && this.state.units.length != 0) {
            this.state.units.map(z => {
                unitList.push({
                    value: z.id,
                    label: z.unitName
                })
            })
        }

        return (
            <div className="NewUser">
                <div className="row justify-content-center">
                    اطلاعات کاربر
                </div>
                <Row xs={2}>
                    {user}
                    <Select
                        name="form-field-name"
                        value={this.state.unit}
                        placeholder="حساب"
                        options={unitList}
                        onChange={this.changeUnit}
                        className={this.state.invalidSelect ? 'invalid-select' : ''}
                        col="6 mt-2"
                    />
                </Row>
                {this.state.showError ?
                    <Row>
                        {this.state.errorContent}
                    </Row>
                    : ''}
                <div className="row justify-content-center">
                    <div className="Roles">
                        <div className="RolesHeader">
                            نقش ها
                        </div>
                        <Row xs={3} className="pr-4 pl-4">
                            {roles}
                        </Row>
                    </div>
                </div>
                {!this.props.view ?
                    <div className="row justify-content-center mt-2">
                        <Button btnType="Success" clicked={this.addUpdateUserSubmit}>ثبت</Button>
                    </div>
                    : ''}
            </div>
        )
    }
}


export default UserForm